import type { CSSProperties } from 'react'
import React from 'react'

import css from './LoadingSkeleton.css'

export const LoadingSkeleton = ({ style }: { style?: CSSProperties }) => (
  <span className={css.loadingSkeleton} style={style} data-testid="loading-skeleton" />
)
